import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHand = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 13.5V5.5C8 5.10218 8.15803 4.72064 8.43934 4.43934C8.72064 4.15804 9.10217 4 9.5 4C9.89782 4 10.2794 4.15804 10.5607 4.43934C10.842 4.72064 11 5.10218 11 5.5M11 5.5V12M11 5.5V3.5C11 3.10218 11.158 2.72064 11.4393 2.43934C11.7206 2.15804 12.1022 2 12.5 2C12.8978 2 13.2794 2.15804 13.5607 2.43934C13.842 2.72064 14 3.10218 14 3.5V12M14 5.5C14 5.10218 14.158 4.72064 14.4393 4.43934C14.7206 4.15804 15.1022 4 15.5 4C15.8978 4 16.2794 4.15804 16.5607 4.43934C16.842 4.72064 17 5.10218 17 5.5V12M17 7.5C17 7.10218 17.158 6.72064 17.4393 6.43934C17.7206 6.15804 18.1022 6 18.5 6C18.8978 6 19.2794 6.15804 19.5607 6.43934C19.842 6.72064 20 7.10218 20 7.5V16C20 17.5913 19.3679 19.1174 18.2426 20.2426C17.1174 21.3679 15.5913 22 14 22H12C10.9564 21.856 9.96442 21.5113 9.09846 20.9917C8.23251 20.4721 7.51508 19.7912 7 19L4.3 13.75C4.03478 13.3853 3.92529 12.9302 3.99562 12.4848C4.06595 12.0394 4.31033 11.6402 4.675 11.375C5.03967 11.1098 5.49476 11.0003 5.94016 11.0706C6.38556 11.1409 6.78478 11.3853 7.05 11.75L7.95 13.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHand;
